<template>
  <div class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <WdsText :sub-text="rateTypeName">{{ column.currency }} {{ formattedRate }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { useTranslation } from '@/composables/translation'

const PaymentRequestRateColumn = graphql(`
  fragment PaymentRequestRateColumn on PaymentRequest {
    id
    currency
    rate
    rateTypeName
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestRateColumn>
}>()

const { $t } = useTranslation()
const column = computed(() => useFragment(PaymentRequestRateColumn, props.row))

const formattedRate = computed(() => {
  if (!column.value.rate) return '0'
  return column.value.rate.toString()
})
const rateTypeName = computed(() => {
  if (!column.value.rateTypeName) return ''
  return $t(column.value.rateTypeName)
})
</script>

<style scoped></style>
